<template>
  <div>
    <div class="sinage-wrapper">
      <div>
        <div class="row border-bottom border-dark mb-4">
          <div class="col-4 align-self-center">
            <img
              src="@/assets/img/logos/logo-white.png"
              height="auto"
              width="100"
              class="img-fluid"
              alt
            />
          </div>
          <div class="col-4">
            <div class="sinage-title">LATEST RELEASE</div>
          </div>
          <div class="col-4 justify-content-end d-flex align-items-center">
            <h5 class="mb-0">{{currentTime}}</h5>
            <h5 class="mb-0 ml-4">{{currentDate}}</h5>
          </div>
        </div>

        <slick ref="slick1" :options="silderOne">
          <div v-for="(show,showKey) in finalMovies" :key="showKey">
            <div class="single-movie">
              <img
                v-if=" show.md_thumbnail_url && show.md_thumbnail_url.length == 0"
                :src="'/static/placeholder-image.png'"
                class="rounded img-fluid d-block mx-auto"
              />
              <img
                v-else
                :src="_GetImagePath(show.md_thumbnail_url)"
                class="rounded img-fluid d-block mx-auto"
              />
              <h5>{{ show.movie_title }}</h5>

              <ul class="sinage-info">
                <li>
                  <div class="sinage-format">{{ show.mf_name }}</div>
                </li>
                <li>
                  <div class="sinage-lang">{{ show.lang_name }}</div>
                </li>
                <li>
                  <div>({{ show.rating }})</div>
                </li>
              </ul>

              <h6>{{show.screen_name}}</h6>
              <ul class="sinage-timing-list mb-0">
                <li
                  v-for="(showTime,ShowTimeKey) in show.showTimes"
                  :key="ShowTimeKey"
                >{{ showTime }}</li>
                <!-- <li>2:30 PM </li>
                <li>4:30 PM </li>
                <li>6:30 PM </li>
                <li>7:00 PM </li>-->
              </ul>
            </div>
          </div>

          <!-- 
          <div>
            <div class="single-movie">
              <img src="https://starapi1.binarynumbers.io/assets/images/movies/AppImage/5d26de77efdf7.jpg"
                class="rounded img-fluid d-block mx-auto" alt="">
              <h5>Angry Birds</h5>
              <ul class="sinage-info">
                <li>
                  <div class="sinage-format"> 2D</div>
                </li>
                <li>
                  <div class="sinage-lang">English</div>
                </li>
                <li>
                  <div>( PG 13 )</div>
                </li>
              </ul>

              <h6>Screen 1</h6>
              <ul class="sinage-timing-list mb-0">
                <li>2:30 PM </li>
                <li>4:30 PM </li>
                <li>6:30 PM </li>
                <li>7:00 PM </li>
              </ul>
            </div>
          </div>-->
        </slick>
      </div>
    </div>
  </div>
</template>

<script>
import signageServices from "@/services/signageService";
import Slick from "vue-slick";
import moment from "moment";

export default {
  components: {
    Slick
  },
  data() {
    return {
      silderOne: {
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: true,
        pauseOnHover: false,
        autoplaySpeed: 40000,
        slidesToScroll: 1,
        slidesToShow: 4
      },

      finalMovies: []
      // currentDate: moment().format("YYYY-MM-DD")
    };
  },
  beforeMount() {
    this.getMovies(this.$route.params.id);
  },
  computed: {
    currentTime() {
      return this.$store.getters.CURRENT_TIME;
    },
    currentDate() {
      return this.$store.getters.CURRENT_DATE;
    }
  },
  methods: {
    getMovies: function(cinema_id) {
      signageServices
        .getLatestRelease(cinema_id)
        .then(response => {
          const { data } = response;
          console.log("response :", response);

          let movies = [];
          data.Records.map(x => {
            movies.push(x);
          });
          console.log("movies :", movies);
          movies.map(x => {
            if (x.ss_id && x.ss_id != null) {
              console.log("x :", x);
              x["showTimes"] = [];
            }
          });
          console.log("movies :", movies);

          data.Records.map(x => {
            movies.map(y => {
              if (
                x.movie_id == y.movie_id &&
                x.movie_details_id == y.movie_details_id &&
                moment(x.ss_start_date.split("T")[0]).format("YYYY-MM-DD") ==
                  moment().format("YYYY-MM-DD")
                // x.mf_id == y.mf_id &&
                // x.lang_id == y.lang_id
              ) {
                y.showTimes.push(x.ss_start_show_time);
              }
            });
          });
          console.log("movies :", movies);

          function removeDuplicates(originalArray, prop) {
            var newArray = [];
            var lookupObject = {};

            for (var i in originalArray) {
              lookupObject[originalArray[i][prop]] = originalArray[i];
            }

            for (i in lookupObject) {
              newArray.push(lookupObject[i]);
            }
            return newArray;
          }
          this.finalMovies = removeDuplicates(movies, "movie_details_id");
          console.log("finalMovies :", this.finalMovies);
          this.$refs.slick1.destroy();
          this.$nextTick(() => {
            this.$refs.slick1.create();
            this.$refs.slick1.goTo(0, true);
          });
        })
        .catch(error => {
          console.log("error :", error);
        });
    }
  }
};
</script>

<style>
.sinage-wrapper {
  width: 100%;
  padding: 20px;
  color: #fff;
  height: 100vh;

  overflow: hidden;
  background: #000000;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to top, #434343, #000000, #000000);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to top, #434343, #000000, #000000);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.sinage-title {
  height: 65px;
  color: #fff;
  font-size: 40px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
}

.sinage-wrapper .single-movie {
  width: 90%;
  padding: 15px 20px;
  margin: 0 auto;
  text-align: left;
  border-radius: 5px;
  background: #222222;
  /* border: 1px solid grey; */
  margin-top: 10px;
  margin-bottom: 10px;
  box-shadow: 1px 1px 10px 3px #8080807a;
}

.single-movie h5 {
  line-height: 1;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 20px;
  padding: 18px 0 15px 0;
  text-transform: uppercase;
  border-bottom: 1px solid GREY;
}

.single-movie img {
  width: 100%;
}

.sinage-info,
.sinage-timing-list {
  padding-left: 0;
  list-style: none;
  margin-bottom: 25px;
  display: inline-flex;
  flex-wrap: wrap;
}

.sinage-info li,
.sinage-timing-list li {
  border-radius: 5px;
  flex-wrap: wrap;
  display: flex;
}

.sinage-timing-list li {
  padding: 5px 15px;
  margin-bottom: 10px;
  border: 1px solid grey;
}

.sinage-timing-list li:not(:last-child) {
  margin-right: 10px;
}

.sinage-info li:not(:last-child):after {
  width: 1px;
  content: "";
  height: 20px;
  display: block;
  margin: 0 10px;
  background-color: #d3d3d3;
}

.sinage-format {
  padding: 4px 8px 3px 8px;
  display: table;
  line-height: 1;
  border-radius: 3px;
  border: 1px solid grey;
  background-color: #000000;
}

.single-movie h6 {
  font-size: 16px;
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Signage/signage_LatestRelease.vue